export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const LANDING = '/'
export const DASHBOARD = '/dashboard'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = '/pw-forget'
export const IMPRESSUM = '/impressum'
export const PRIVACY_POLICY = '/privacy-policy'
export const FAQ = '/FAQ'
export const INTRO_QUESTIONS = '/intro-questions'
export const INTRO_QUESTIONS_SUCCESS = '/intro-questions-success'
export const SETTINGS = '/settings'
export const PLANTS = '/plants'
export const PLANT = `${PLANTS}/:id`
export const DEVICES = '/devices'
export const DEVICE = `${DEVICES}/:uuid`
export const SENSOR_DEVICE = `${DEVICES}/sensors/:uuid`
export const VALVE_DEVICE = `${DEVICES}/valves/:uuid`
export const CLASSIFIER = '/classifier'
export const PLANT_CLASSIFICATION = '/classifier/plant'

export const FLOWERAI_WEBSITE = 'http://www.flowerai.de'



// WEBPACK FOOTER //
// ./src/constants/routes.js